module.exports = __webpack_public_path__ + "static/img/20.4a0ed83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/20.jpg
// module id = fPEH
// module chunks = 0